import $ from "jquery";
import { centralmanager } from "../shim/jsbridge";

const sectionToFieldsetSelector = {
  s3_integration: "#config-system-s3 .s3-fieldset",
  email: "#config-system-smtp",
  ntp: "#config-system-time",
  cloud: "#config-system-titaniumcloud",
  t1000: "#config-system-t1000",
  snmp: "#config-system-snmp",
  systemalerting: "#config-systemalerting, #config-emailalerting",
  resource_usage_limits: "#config-system-resource_usage_limits",
  backup: "#config-backup-and-purge",
  system_health: "#config-health-status-indicator"
};

const disableManagedSections = () => {
  const managed_config_sections = centralmanager.managed_config_sections;
  managed_config_sections.forEach(section => {
    const sectionSelector = sectionToFieldsetSelector[section];
    if (sectionSelector === undefined) {
      return; // Skip section (e.g. ldap, oidc)
    }

    const $fieldset = $(sectionSelector);
    $fieldset
      .children("legend")
      .append(
        "&nbsp;&nbsp;<span>(configured by Spectra Detect Manager)</span>"
      );
  });
};

export default disableManagedSections;
